import React from 'react';
import { StyleSheet, Text } from 'react-native';
import { useNavigation } from '@react-navigation/native';
import { CalcScreen, CategoryCard } from '../../components/shell';
import { C, FONT, SP } from '../../theme/tokens';

type Calc = { title: string; description: string; screen: string };

const CALCS: Calc[] = [
  { title: 'ISO 14644-1 Particle Count', description: 'Class limits, sample volume, locations, and time per ISO 14644-1', screen: 'CleanroomParticleCountCalculator' },
  { title: 'Particle Concentration', description: 'Particle concentration from count and sample volume', screen: 'CleanroomParticleConcentration' },
];

export default function CleanroomParticleCountingScreen() {
  const nav = useNavigation();
  return (
    <CalcScreen title="Particle Counting" subtitle="Cleanroom particle concentration and sampling">
      <Text style={styles.sectionLabel}>Calculations</Text>
      {CALCS.map((c) => (
        <CategoryCard
          key={c.screen}
          title={c.title}
          description={c.description}
          cta="Open →"
          onPress={() => nav.navigate(c.screen as never)}
        />
      ))}
    </CalcScreen>
  );
}

const styles = StyleSheet.create({
  sectionLabel: {
    fontFamily: FONT.sans,
    fontSize: 12,
    color: C.dim,
    textTransform: 'uppercase',
    letterSpacing: 0.6,
    marginBottom: SP.sm,
  },
});
